module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex mb-4 flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Horas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.hours),
      expression: "filter.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "hours", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sin horas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Hora")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("+1 Hora")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])])])])])])], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('h1', {
    staticClass: "mb-2 text-lg font-bold"
  }, [_vm._v("\n      Proyectos (" + _vm._s(_vm.filteredProjects.length) + ")\n    ")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
    }, [_c('div', {
      staticClass: "bg-white mb-1 flex justify-between rounded-md py-3 px-5 sm:px-10 relative zoom-in"
    }, [_c('div', {
      staticClass: "w-1/3 block font-medium ext-center truncate"
    }, [_vm._v("\n          " + _vm._s(project.name) + "(" + _vm._s(project.hours) + ")\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-center"
    }, [_vm._v("\n          " + _vm._s(project.account.name) + " - " + _vm._s(project.account.country.prefix) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "file__icon__file-name"
    }, [_vm._v("\n          " + _vm._s(project.status === 0 ? 'Inactivo' : 'Activo') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('router-link', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": '/admin/traffic/project/' + project.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                Editar\n              ")], 1), _vm._v(" "), _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeProject(project)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                Eliminar\n              ")], 1)], 1)])])])])
  })], 2) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "project"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createProject.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.name),
      expression: "project.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.project.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.account_id),
      expression: "project.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.user_id),
      expression: "project.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return (user.roles[0].id >= 3) ? _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Horas (Digital)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.hours),
      expression: "project.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.project.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "hours", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#project",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Proyecto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Proyecto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23183116","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/project/ListProject.vue
// module id = 419
// module chunks = 1